import React from "react";
import PdfViewer from "../../PdfViewer";

const ProcesosPOC = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/proceso-POC.pdf`;
  /*const pdfUrl = "/pdf/proceso-POC.pdf";*/

  console.log("PDF URL:", pdfUrl);

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Procesos POC - Diagrama</h1>
        </div>
        <div class="sub-titulo">
          <h2>Descripción detallada del procedimiento</h2>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default ProcesosPOC;
